var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("radio-button-option-row", {
        key: _vm.radioButtonValueChanged,
        attrs: {
          title: _vm.locationTitle,
          required: true,
          options: _vm.locationOptions
        },
        model: {
          value: _vm.location.locationType[0],
          callback: function($$v) {
            _vm.$set(_vm.location.locationType, 0, $$v)
          },
          expression: "location.locationType[0]"
        }
      }),
      _vm._v(" "),
      _vm.showMunicipalities
        ? _c("municipalities-control", {
            staticClass: "mt-4",
            attrs: { title: _vm.municipalitiesTitle, required: true, max: 50 },
            model: {
              value: _vm.location.municipalities,
              callback: function($$v) {
                _vm.$set(_vm.location, "municipalities", $$v)
              },
              expression: "location.municipalities"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showRegions
        ? _c("regions-control", {
            attrs: { title: _vm.regionsTitle, required: true },
            model: {
              value: _vm.location.regions,
              callback: function($$v) {
                _vm.$set(_vm.location, "regions", $$v)
              },
              expression: "location.regions"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showWellbeingServiceCounties
        ? _c("wellbeing-service-counties-control", {
            attrs: { title: _vm.wellbeingServiceCountiesTitle, required: true },
            model: {
              value: _vm.location.wellbeingServiceCounties,
              callback: function($$v) {
                _vm.$set(_vm.location, "wellbeingServiceCounties", $$v)
              },
              expression: "location.wellbeingServiceCounties"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showChannels
        ? _c("check-box-list-row", {
            attrs: {
              title: "AidApplication.BasicInfo.Channel.Title",
              options: _vm.channelOptions
            },
            model: {
              value: _vm.location.channels,
              callback: function($$v) {
                _vm.$set(_vm.location, "channels", $$v)
              },
              expression: "location.channels"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }